// extracted by mini-css-extract-plugin
export default {"miniRedirectPage":"miniRedirectPage--SU6Ap"};